import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, Select, Checkbox, Tooltip, Typography, message, DatePicker } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { dateFormat } from '../utils';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

function UpdateStage(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
            const stage = props.stage;
            const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ')
            // values.date = stringDate
            stage.name = values.name;
            stage.date = stringDate;
            stage.stageNumber = values.stageNumber;
            stage.round = 1;
            // TODO: se round è 0 o undefined, mettiamo round a 1, altrimenti si blocca tutto. 
            // In futuro, se vogliamo permettere di inserire round diversi da 1, dobbiamo gestire meglio questo aspetto.
            // stage.round = values.round;
            stage.turns = values.turns;
            stage.isDone = values.isDone;

            //console.warn('Form values not valid!', values);

            const response = await fetch(api.stages().update(stage.id).href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Setting.getToken(),
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(stage) // body data type must match "Content-Type" header
            })
            .then((data) => data.json())

            if (response.errorMsg === "") {
                window.location.reload(false);
            } else {
                messageApi.error("You do not have the permission to edit this tournament status! Check the inserted infos.");
            }
        })
        .catch((errorInfo) => {
            // console.warn('errorInfo:', errorInfo);
            messageApi.error("Please compile all required fields of the form!");
        })
    }

    //TODO: add isDone value to initialValues.
    return(
            <div>
                {contextHolder}
                <Modal title={t('stages.update')} open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ "name": props.stage.name, "date": dayjs(props.stage.date), "stageNumber": props.stage.stageNumber, "round": props.stage.round, "turns": props.stage.turns, isDone: props.stage.isDone }}>
                        <Form.Item label={t('stages.labelName')} name="name">
                            <Input placeholder="Name" />
                        </Form.Item>
                        <Form.Item label={t('stages.labelDate')} name="date">
                            <DatePicker placeholder="Date" format="DD/MM/YYYY" />
                        </Form.Item>
                        <Form.Item label={t('stages.labelNumber')} name="stageNumber">
                            <InputNumber placeholder='Stage Nr.' />
                        </Form.Item>
                        <Form.Item label="Leg Number" name="round" style={{ display: 'none' }}>
                            <InputNumber placeholder='Leg Number' />
                        </Form.Item>
                        <Form.Item label={t('stages.labelTurns')} name="turns">
                            <InputNumber min={0} max={10} placeholder='Swiss Rounds' />
                        </Form.Item>
                        <Form.Item label={t('stages.isDone')} name="isDone" valuePropName="checked" tooltip={t('stages.isDoneTooltip')}>
                            <Checkbox />
                        </Form.Item>
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                   {t('stages.update')}
                </Button>
            </div>
    )
}

export default UpdateStage;